export enum ChatMessageAuthorType {
  Investor = 'investor',
  Manager = 'manager',
  System = 'system',
}
